const form = {
  requiredEmail: "L'adresse email est obligatoire.",
  requiredPassword: "Le mot de passe est obligatoire.",
  requiredUserType: "Veuillez sélectionner un type de compte",
  dateMustBeComplete: "La date doit être complète.",
  requiredExample: "L'exemple est obligatoire.",
  requiredFirstname: "Le prénom est obligatoire.",
  requiredLastname: "Le nom est obligatoire.",
  requiredMessage: "Le message ne peut pas être vide.",
  requiredCity: "La ville est obligatoire.",
  validEmail: "Veillez à entrer une adresse email valide.",
  tooLong: "Ce champs est limité à {value} caractères.",
  subject: "Sujet",
  description: "Description",
  category: "Catégorie",
  acceptDataProcessing:
    "J'accepte que mes données soient partagées avec l'équipe de développement.",
  invalidForm: "Formulaire invalide.",
  requiredFields: "Les champs marqués d'un * sont obligatoires.",
  allFieldsRequired: "Tous les champs sont obligatoires.",
};

export default form;
